import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/topicLinkTypeService";
const store = {};
const mutations = {
    GET_LIST(state, posts) { 
        state.topicLinkTypeList = posts;
    },
    SAVE_LIST(state, posts) {
        state.topicLinkTypeList = posts;
    },
};
const state = {
    topicLinkTypeList: [],
};
const getters = {};
const actions = {
    getTopicLinkTypeList({ commit }) {
        return axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_LIST', res.data.list);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    saveTopicLinkTypeList({ commit }, data) {
        var formData = new FormData();
        formData.append("updates", JSON.stringify(data.updates));
        formData.append("remove", JSON.stringify(data.remove));
        formData.append("insert", JSON.stringify(data.insert));
        return axios
            .post(baseUri + '/UpdateList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_LIST', res.data.list);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
                return res;
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}